import React, { ReactElement } from 'react';

interface IconBurgerProps {
    color?: string;
    className?: string;
}

export default function IconBurger({ color = 'white', className }: IconBurgerProps): ReactElement {
    return (
        <svg
            width='24px'
            height='24px'
            viewBox='0 0 24 24'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g
                id='Jamie-Working-File'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
            >
                <g
                    id='MO-Admin-Landing-Page---Profile'
                    transform='translate(-1217.000000, -27.000000)'
                    stroke={color ?? '#FFFFFF'}
                    strokeWidth='2'
                >
                    <g id='Drawer' transform='translate(1217.000000, 27.000000)'>
                        <g id='drawer' transform='translate(5.000000, 3.000000)'>
                            <line x1='0' y1='1' x2='14' y2='1' id='Line' />
                            <line x1='0' y1='9' x2='14' y2='9' id='Line' />
                            <line x1='0' y1='17' x2='14' y2='17' id='Line' />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
